<div *ngIf="checkingDistrict" class="text-center p-4">
  <span>Cargando información de distrito...</span>
</div>

<div *ngIf="!checkingDistrict && !hasDistrict" class="alert alert-info m-3" role="alert">
  No tienes distrito a cargo.
</div>

<ng-container *ngIf="!checkingDistrict && hasDistrict">
<form [formGroup]="districtDataForm" (ngSubmit)="saveDistrictData()">
  <div class="table-responsive">
    <table class="table table-bordered table-hover align-middle district-data-table">
      <tbody>
        <tr>
          <th>Periodo</th>
          <td class="answer-cell">
            <select id="periodo" class="form-select" formControlName="periodo">
              <option *ngFor="let period of periodOptions" [value]="period.id">{{ period.label }}</option>
            </select>
          </td>
        </tr>
        <tr>
          <th>Distrito</th>
          <td class="answer-cell">
            <select id="distrito" class="form-select" formControlName="distrito">
              <option *ngFor="let district of districtOptions" [value]="district.id">{{ district.label }}</option>
            </select>
          </td>
        </tr>
        <tr>
          <th>Iglesia</th>
          <td class="answer-cell">
            <select id="iglesia" class="form-select" formControlName="iglesia">
              <option *ngFor="let church of churchOptions" [value]="church.id">{{ church.label }}</option>
            </select>
          </td>
        </tr>
        <tr>
          <th>1) Cierre de remesas al día?</th>
          <td class="answer-cell">
            <select id="cierreRemesasAlDia" class="form-select" formControlName="cierreRemesasAlDia">
              <option value="Si">Si</option>
              <option value="No">No</option>
            </select>
          </td>
        </tr>
        <tr>
          <th>2) Voto de informe de tesorería de iglesia local</th>
          <td class="answer-cell">
            <input type="text" id="votoInformeTesoreria" class="form-control" formControlName="votoInformeTesoreria" />
          </td>
        </tr>
        <tr>
          <th>3) Cuántos miembros participaron de algún programa o acciones de Identidad?</th>
          <td class="answer-cell">
            <input type="number" min="0" id="participantesIdentidad" class="form-control" formControlName="participantesIdentidad" />
          </td>
        </tr>
        <tr>
          <th>4) Cantidad de personas participando del curso Creciendo en Cristo?</th>
          <td class="answer-cell">
            <input type="number" min="0" id="participantesCreciendoEnCristo" class="form-control" formControlName="participantesCreciendoEnCristo" />
          </td>
        </tr>
        <tr>
          <th>5) Cuántos líderes participaron de algún programa de liderazgo (Premistrales, Mayordomía, Escuelas de Tesorería, Evangelismo, Libertad Religiosa, etc)?</th>
          <td class="answer-cell">
            <input type="number" min="0" id="lideresProgramasLiderazgo" class="form-control" formControlName="lideresProgramasLiderazgo" />
          </td>
        </tr>
        <tr>
          <th>6) Cuántos hermanos participaron de la escuela misionera?</th>
          <td class="answer-cell">
            <input type="number" min="0" id="participantesEscuelaMisionera" class="form-control" formControlName="participantesEscuelaMisionera" />
          </td>
        </tr>
        <tr>
          <th>7) Número de personas dando estudios bíblicos?</th>
          <td class="answer-cell">
            <input type="number" min="0" id="personasEstudioBiblicos" class="form-control" formControlName="personasEstudioBiblicos" />
          </td>
        </tr>
        <tr>
          <th>8) Número de estudiantes de la Biblia?</th>
          <td class="answer-cell">
            <input type="number" min="0" id="estudiantesBiblia" class="form-control" formControlName="estudiantesBiblia" />
          </td>
        </tr>
        <tr>
          <th>9) Número de bautismos durante el mes?</th>
          <td class="answer-cell">
            <input type="number" min="0" id="bautismosMes" class="form-control" formControlName="bautismosMes" />
          </td>
        </tr>
        <tr>
          <th>10) Número de bautismos acumulado a la fecha?</th>
          <td class="answer-cell">
            <input type="number" min="0" id="bautismosAcumulado" class="form-control" formControlName="bautismosAcumulado" />
          </td>
        </tr>
        <tr>
          <th>11) Número de fichas de bautismos pendientes?</th>
          <td class="answer-cell">
            <input type="number" min="0" id="fichasBautismosPendientes" class="form-control" formControlName="fichasBautismosPendientes" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div *ngIf="!canEditSurvey" class="alert alert-warning mt-3" role="alert">
    No puedes modificar la encuesta distrital de este periodo porque tu informe ya fue enviado.
  </div>

  <div class="mt-3">
    <button type="submit" class="btn btn-primary" [disabled]="!canEditSurvey">{{ isEdit ? 'Actualizar datos distritales' : 'Guardar datos distritales' }}</button>
    <button type="button" class="btn btn-secondary ms-2" *ngIf="isEdit" (click)="cancelEdit()">Cancelar edición</button>
  </div>
</form>

<div class="mt-4">
  <h5>Resultados de encuestas por iglesias</h5>
  <div class="table-responsive">
    <table class="table table-bordered table-striped mt-2">
      <thead class="table-light">
        <tr>
          <th>Periodo</th>
          <th>Distrito</th>
          <th>Iglesia</th>
          <th>Cierre de remesas al día</th>
          <th>Voto informe tesorería</th>
          <th>Fichas Bautismos Pendientes</th>
          <th>Participantes Identidad</th>
          <th>Creciendo en Cristo</th>
          <th>Líderes en liderazgo</th>
          <th>Escuela misionera</th>
          <th>Estudios bíblicos</th>
          <th>Estudiantes Biblia</th>
          <th>Bautismos mes</th>
          <th>Bautismos acumulado</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let result of surveyResults">
          <td>{{ result.periodo }}</td>
          <td>{{ result.distrito }}</td>
          <td>{{ result.iglesia }}</td>
          <td>{{ result.cierreRemesasAlDia }}</td>
          <td>{{ result.votoInformeTesoreria }}</td>
          <td>{{ result.fichasBautismosPendientes }}</td>
          <td>{{ result.participantesIdentidad }}</td>
          <td>{{ result.participantesCreciendoEnCristo }}</td>
          <td>{{ result.lideresProgramasLiderazgo }}</td>
          <td>{{ result.participantesEscuelaMisionera }}</td>
          <td>{{ result.personasEstudioBiblicos }}</td>
          <td>{{ result.estudiantesBiblia }}</td>
          <td>{{ result.bautismosMes }}</td>
          <td>{{ result.bautismosAcumulado }}</td>
          <td>
            <button class="btn btn-warning btn-sm" title="Editar" [disabled]="!canEditSurvey" (click)="editSurvey(result)">
              <i class="bi bi-pencil-square"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
</ng-container>
